import {
    PICKUP_CANCEL_ROUTE,
    PICKUP_PICK_ROUTE,
    PICKUP_DETAILS_ROUTE,
    PICKUP_PICKING_ROUTE,
    PICKUP_PACKING_ROUTE,
    PICKUP_TITLE_PREFIX,
    PICKUP_DOMAIN_NAME
} from '../../../modules/fulfillment/consts';

import { ORDERS_DETAILS_ROUTE } from '../../../modules/orders/consts';
import { PRODUCTS_DETAILS_ROUTE } from '../../../modules/products/consts';

export default {
    name: 'pickupFulfillmentPickingPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'pickupPicking';
        const route = app.routes.getItem(routeName);

        if (route) {
            const routeProps = route.props;
            route.props = (state) => {
                return {
                ...routeProps(state),
                correctOrderRequired: false,
                withLocationStep: false,
                // to validate when new core release will be updated
                routes: {
                    orderDetailsPageRoute: ORDERS_DETAILS_ROUTE,
                    detailsPageRoute: PICKUP_DETAILS_ROUTE,
                    pickingPageRoute: PICKUP_PICKING_ROUTE,
                    packingPageRoute: PICKUP_PACKING_ROUTE,
                    pickPageRoute: PICKUP_PICK_ROUTE,
                    cancelPageRoute: PICKUP_CANCEL_ROUTE,
                    productDetailsPageRoute: PRODUCTS_DETAILS_ROUTE,
                    itemsPrintPageRoute: `/fulfillment-pickup/print-items`,
                    shipmentDetailsPageRoute: '',
                },
                permissions: {
                    canCancel: true,
                    canAssignUser: true,
                    canUnassignUser: true,
                    canPrintItems: true,
                    withProductDetailsLink:true,
                    withOrderDetailsLink: true,
                },
            }};

            app.routes.changeItem(routeName, route);


            app.routes.addItem('pickupShipPrintItems', {
                path: `/fulfillment-pickup/print-items/:id`,
                title: `${PICKUP_TITLE_PREFIX} > Print Items`,
                permission: ['fulfillments.show'],
                breadcrumbConfig: { title: ' ', isReplaceble: true },
                props: () => ({
                    domain: PICKUP_DOMAIN_NAME,
                }),
                loader: () => import('@skunexus/pickup-print-items'),
            })
        }
    },
};
